module.exports = __webpack_public_path__ + "img/base-triple-wheel.19f89a52.png";